export interface Preference<T> {
    id?: ID;
    key: PreferenceKey;
    value: T;
    seller: { id: ID };
    context: PreferenceContext;
}

export enum PreferenceContext {
    SELLER = "seller",
    USER = "user",
}

export enum PreferenceKey {
    XOLA_SELLER_DASHBOARD = "xola.seller.dashboard",
    XOLA_SELLER_ROSTER = "xola.seller.roster",
    XOLA_SELLER_DASHBOARD_COLORS = "xola.seller.experience.color",
    XOLA_SELLER_PARTNER = "xola.seller.partner",
    XOLA_SELLER_PREFS_KIOSK = "xola.seller.preferences.kiosk",
    FRAUD_PREVENTION_SETTINGS = "fraudPrevention.settings",
}

export interface SellerPartnerPreference extends Preference<SellerPartnerPreferenceValue> {
    key: PreferenceKey.XOLA_SELLER_PARTNER;
}

export interface SellerPartnerPreferenceValue {
    selectedProducts: ID[];
    partnerSeller: ID;
}

export interface XChatDisabledPreferenceValue {
    value: boolean;
}

export interface ThumbnailMetadata {
    thumbnail: string;
    [key: string]: string | number | boolean | null | undefined;
}
export type MediaThumbnailsPreferenceValue = Record<string, ThumbnailMetadata>;

export interface Paging {
    total?: number;
    limit?: number;
    offset?: number;
    [key: string]: any;
}

export interface PreferenceList<T = unknown, P = Paging> {
    data: Preference<T>[];
    paging?: P;
}
